import * as React from 'react';
import { COMMUNITY_ROLES } from '@/constants/community-roles';
import { USER_ROLES } from '@/constants/user-roles';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import { paths } from '@/paths';
import AnnouncementPage from '@/pages/announcement';
import AnnouncementsPage from '@/pages/announcements';
import { RoleGuard } from '@/components/auth/guards/role-guard';
import { ACCOUNT_ROLES } from '@/constants/account-roles';

export const route: RouteObject = {
  path: paths.announcements.index,
  element: (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  ),
  children: [
    {
      index: true,
      element: (
        <RoleGuard
          requiredAccountRoles={[ACCOUNT_ROLES.ACCOUNT_ADMIN]}
          requiredCommunityRoles={[COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER]}
        >
          <AnnouncementsPage />
        </RoleGuard>
      ),
    },
    {
      path: paths.announcements.announcement(':announcementId'),
      element: (
        <RoleGuard
          requiredAccountRoles={[ACCOUNT_ROLES.ACCOUNT_ADMIN]}
          requiredCommunityRoles={[COMMUNITY_ROLES.COMMUNITY_MANAGER, COMMUNITY_ROLES.COMMUNITY_MEMBER]}
        >
          <AnnouncementPage />
        </RoleGuard>
      ),
    },
  ],
};
